import { Navigate, Outlet, useLocation } from "react-router-dom";
import { MainNavbar } from "../components/HeaderNav";
import { getAuthAdminAccess } from "../helper";
import { useDispatch, useSelector } from "react-redux";
import ErrorPage from "../pages/ErrorPage";
import { RootState } from "../store";
import { useEffect } from "react";
import { updateTestMode } from "../services/staticSlice";
import { CloseIconHeader } from "../components/Icons/iconImages";

function PrivateRoute() {
  const location = useLocation();
  const restrictedPaths = ["/onboardingIntegration", "/integrations", '/create-profile'];
  let isAuth = getAuthAdminAccess();
  const testMode = useSelector((state: RootState) => state.static.testMode);
  const workSpaceId = useSelector((state: RootState) => state.static.workSpaceId);
  const dispatch = useDispatch();
  let workspaceId = localStorage.getItem("workspace_id");
  let testModeSession = sessionStorage.getItem('oogwai_testMode_close');
  const tokenType = localStorage.getItem("oogw.ai_user_type") || "Bearer";


  // useEffect(() => {
  //   dispatch(updateTestMode(workspaceId === "Demo" && testModeSession !== "true" && tokenType !== "Shopify" ? true : false));
  // }, [workspaceId, testModeSession, workSpaceId])

  return !isAuth ? (
    <Navigate to="/" />
  ) : (
    <>
      <div className="bg-[#4C8067] fixed top-[0px] h-[50px] w-full z-50 ">
        <p className="text-sm text-[#FFFFFF] font-semibold text-center flex justify-center relative top-[15px] z-[-1]">You are browsing Oogwai in Test Mode</p>
        <CloseIconHeader className="ml-auto mr-[20px] cursor-pointer" onClick={() => { sessionStorage.setItem("oogwai_testMode_close", "true"); dispatch(updateTestMode(false)) }} />
      </div>
      <MainNavbar />
      <div
        className={`px-2 md:px-6 ${testMode ? 'pt-[7rem]' : 'pt-14'} transition-all duration-150 ${restrictedPaths.includes(location.pathname) ? "bg-gray-100" : "bg-white"
          }`}
      >
        <div
          className={`page-min-height ${location.pathname === "/dashboard" ? "dashboard-wrapper" : "page-content"
            }`}
          key={location.pathname}
        >
          <Outlet />
        </div>
      </div>
    </>
  );
}

export default PrivateRoute;
